enum LangType {
  zh = 'CN',
  en = 'EN',
  id = 'ID'
}
export default LangType
